import {
  FunctionComponent,
  PropsWithChildren,
  ReactNode,
  useEffect,
} from "react";

import { coralService } from "@framework/coral/CoralService";
import CoralCommentsContext from "@voxmedia/duet-context/context/coral-comments-context";

interface Props {
  children?: ReactNode;
}

/**
 * Service provider for Coral comment counts functionality.
 */
const CoralCountsProvider: FunctionComponent<PropsWithChildren<Props>> = ({
  children,
}) => {
  useEffect(() => {
    if (process.env.CORAL_TENANT_ID) {
      coralService.loadAllCountsFromIndexedDB().catch((error: unknown) => {
        console.warn("Failed to load comment counts from IndexedDB:", error);
      });
    }
  }, []);

  return (
    <CoralCommentsContext.Provider value={coralService}>
      {children}
    </CoralCommentsContext.Provider>
  );
};

export default CoralCountsProvider;
